<template>
  <b-modal
    hide-footer
    lazy
    id="modal-digital-id-company"
    ref="modal-digital-id-company"
    size="xl"
    title="เพิ่มข้อมูล"
    @show="buildIframeSrc"
    @hidden="clearIframeSrc"
  >
    <iframe
      v-if="iframeSrc"
      :src="iframeSrc"
      id="i-frame"
      width="100%"
      height="800"
      frameborder="0"
      crossorigin
    >
    </iframe>
    <b-alert v-else variant="danger" show class="mb-0">
      ไม่สามารถเปิดฟอร์มข้อมูลผู้ประกอบธุรกิจได้
      เนื่องจากไม่พบข้อมูลผู้ใช้งานที่เข้าสู่ระบบ
      กรุณาออกจากระบบและเข้าสู่ระบบใหม่อีกครั้ง
    </b-alert>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BAlert,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BModal,
  BForm,
  BButton,
  BFormTextarea,
  BFormDatepicker,
} from "bootstrap-vue";

import vSelect from "vue-select";
import { VueAutosuggest } from "vue-autosuggest";
import * as ComplaintAPI from "@/store/api/complaint/complaint.js";
import * as lang from "vuejs-datepicker/src/locale";
import * as userData from "@/auth/localStorageUtils.js";
import * as digitalIdEmbed from "./digitalIdEmbed.js";

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BFormDatepicker,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    vSelect,
    VueAutosuggest,
    ComplaintAPI,
    lang,
    userData,
  },
  data() {
    return {
      iframeSrc: null,
    };
  },
  props: {
    compId: {
      type: String,
    },
  },
  methods: {
    // ประกอบ URL ใหม่ทุกครั้งที่เปิด modal ถ้าปล่อยให้ผูกกับ prop ตรงๆ
    // การเปิดซ้ำด้วยค่าเดิมจะไม่ทำให้ iframe โหลดใหม่ และจะเห็นหน้าเดิมที่ค้างอยู่
    buildIframeSrc() {
      this.iframeSrc = digitalIdEmbed.buildUrl("Company/FullPageManage", {
        id: this.compId,
      });
    },
    clearIframeSrc() {
      this.iframeSrc = null;
    },
    iframeSubmit(event) {
      // รับเฉพาะ message ที่มาจากแอป Digital ID และเฉพาะตอนที่ modal นี้เปิดอยู่
      if (!this.iframeSrc || event.origin !== digitalIdEmbed.digitalIdOrigin()) {
        return;
      }
      if (event.data === null || typeof event.data !== "object") {
        return;
      }
      if (event.data.type === "submit") {
        //console.log('iframe event submit', event.data)
        this.$emit("handle-success", event.data.data.id);
      } else if (event.data.type === "cancel") {
        console.log("iframe event cancel");
        this.$refs["modal-digital-id-company"].hide();
      }
    },
  },
  mounted() {
    window.addEventListener("message", this.iframeSubmit);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.iframeSubmit);
  },
};
</script>

<style></style>
